import { sidebarPage } from '../utils/sidebarPageLayout.js';

export class AboutUs {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const main = `
            <section class="fg-card">
                <h2 class="fg-section-title">Our Story</h2>
                <p class="fg-prose">
                    FootballGirl was founded with a simple yet powerful vision: to create a comprehensive
                    platform that celebrates, supports, and advances women's football worldwide. We believe
                    that female football deserves the same recognition, resources, and opportunities as the
                    men's game.
                </p>
                <p class="fg-prose">
                    Since our inception, we've been dedicated to providing fans, players, coaches, and
                    clubs with the tools, information, and community they need to thrive in the world of
                    women's football. From grassroots development to professional leagues, we're committed
                    to being the go-to destination for everything related to female football.
                </p>
            </section>

            <section class="fg-hero">
                <h2 class="fg-hero__title">Our Mission</h2>
                <p class="fg-hero__text">
                    To empower and elevate women's football by providing comprehensive coverage,
                    resources, and opportunities that inspire the next generation of female football
                    players, coaches, and fans. We're building a global community that celebrates
                    the beautiful game in all its forms.
                </p>
            </section>

            <div class="fg-grid">
                <article class="fg-card fg-card--muted">
                    <div class="fg-service-card__icon" aria-hidden="true">⚽</div>
                    <h3 class="fg-service-card__title">Excellence</h3>
                    <p class="fg-service-card__desc">
                        We strive for excellence in everything we do, from our content quality to
                        our community engagement and support for the women's game.
                    </p>
                </article>
                <article class="fg-card fg-card--muted">
                    <div class="fg-service-card__icon" aria-hidden="true">🤝</div>
                    <h3 class="fg-service-card__title">Community</h3>
                    <p class="fg-service-card__desc">
                        We believe in the power of community and work to create inclusive spaces
                        where everyone feels welcome and supported in their football journey.
                    </p>
                </article>
                <article class="fg-card fg-card--muted">
                    <div class="fg-service-card__icon" aria-hidden="true">🌍</div>
                    <h3 class="fg-service-card__title">Global Reach</h3>
                    <p class="fg-service-card__desc">
                        We celebrate the global nature of women's football and work to connect
                        players, fans, and communities from around the world.
                    </p>
                </article>
                <article class="fg-card fg-card--muted">
                    <div class="fg-service-card__icon" aria-hidden="true">💪</div>
                    <h3 class="fg-service-card__title">Empowerment</h3>
                    <p class="fg-service-card__desc">
                        We're committed to empowering female athletes, coaches, and leaders
                        through education, opportunities, and representation.
                    </p>
                </article>
                <article class="fg-card fg-card--muted">
                    <div class="fg-service-card__icon" aria-hidden="true">🎯</div>
                    <h3 class="fg-service-card__title">Innovation</h3>
                    <p class="fg-service-card__desc">
                        We embrace innovation and technology to create better experiences and
                        opportunities for the women's football community.
                    </p>
                </article>
                <article class="fg-card fg-card--muted">
                    <div class="fg-service-card__icon" aria-hidden="true">❤️</div>
                    <h3 class="fg-service-card__title">Passion</h3>
                    <p class="fg-service-card__desc">
                        Our passion for women's football drives everything we do, from our
                        content creation to our community building efforts.
                    </p>
                </article>
            </div>

            <section class="fg-sample-block">
                <h2 class="fg-section-title">Our Team</h2>
                <p class="fg-prose">
                    FootballGirl is powered by a diverse team of football enthusiasts, journalists,
                    developers, and community builders who share a common passion for advancing
                    women's football. Our team brings together expertise from various fields to
                    create a comprehensive platform that serves the global women's football community.
                </p>
                <p class="fg-prose">
                    We're constantly growing and evolving, always looking for new ways to support
                    and celebrate the beautiful game. Join us in our mission to make women's
                    football the most accessible, celebrated, and supported sport in the world.
                </p>
            </section>
        `;

        el.innerHTML = sidebarPage({
            title: 'About Us',
            subtitle: 'Learn more about FootballGirl and our mission',
            main
        });
    }
}
